import { fontSize, fontWeight } from '@/styles/font'
import BaseHeading from './BaseHeading'
import { type HeadingProps } from './props'
import { memo } from 'react'

const Heading2 = (props: HeadingProps): JSX.Element => {
  return (
    <BaseHeading
      fontSize={fontSize.XL}
      fontSizeSP={fontSize.M}
      fontWeight={fontWeight.Bold}
      {...props}
    >
      {props.children}
    </BaseHeading>
  )
}

export default memo(Heading2)
